const styles = () => ({
  container: {
    width: '100%',
    margin: '0',
  },
  containerPadding: {
    padding: '24px',
  },
  Avatarimg: {
    width: '60px',
    height: '60px',
  },

  nameTitle: {
    textTransform: 'capitalize',
    fontSize: '14px',
  },

  avatarV2Container: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
  },

  strongText: {
    fontSize: '16px',
    fontWeight: '600',
  },
  itemContainer: {},
  '@media (max-width: 767px)': {
    containerPadding: {
      padding: '16px',
    },
  },
});
export default styles;
